export const registerFormId = 'ece02308-1eaa-422e-925c-2910462ca022'
export const registerStepId = 'bca73f12-2f87-424e-a450-6e48c9c0d190'

export const cardsFormId = '180a2ac8-bb4f-478a-9038-1f3e206b4e12'

export const investmentsFormId = '1d315834-cbf5-4c36-81f6-d91179e018c8'

export const loansFormId = '760d2c58-484d-4fc2-9106-7fcdfb193e50'
